import React from 'react'

export type Ref = HTMLSpanElement

type Props = {
  name?: string
  fixedWidth?: boolean
  spin?: boolean
  className?: string
  style?: React.CSSProperties
} 

const KanBoIcon = React.forwardRef<Ref, Props>(({ name, fixedWidth, spin, className, ...props }, ref) => {
  let _className = 'kanbo-icon'
  if (name) _className += ' ' + name
  if (fixedWidth) _className += ' kanbo-icon-fw'
  if (spin) _className += ' kanbo-icon-spin'
  if (className) _className += ' ' + className

  return (
    <span
      {...props}
      ref={ref}
      className={_className}
    />
  )
})

KanBoIcon.displayName = 'KanBoIcon'

export default KanBoIcon
